import * as Yup from 'yup';
import { isContentLocaleEnabled } from '@/lib/platform-filters';

export const optionValidationSchema = Yup.object({
  option_text_en: Yup.string()
    .required('English option text is required')
    .min(1, 'English option text is required'),
  /**
   * Required only where the instance declares this Content Locale (CAE-762). The authoring
   * form renders no box for it otherwise, so a required rule would make every hand-authored
   * Question unsavable — one error per Option, each naming a field the Game Manager cannot
   * see.
   *
   * A `.test` rather than a conditional chain, so the declaration is read when a Question is
   * validated rather than when this module is imported: a rule frozen at import time gates
   * on whatever was declared then, which traps any consumer holding a long-lived reference.
   */
  option_text_fr: Yup.string()
    .nullable()
    .test('content-locale-required', 'Spanish option text is required', value =>
      isContentLocaleEnabled('fr') ? Boolean(value) : true
    ),
  option_image_en: Yup.string().url('Must be a valid URL').nullable(),
  option_image_fr: Yup.string().url('Must be a valid URL').nullable(),
  third_image_en: Yup.string().url('Must be a valid URL').nullable(),
  third_image_fr: Yup.string().url('Must be a valid URL').nullable(),
  is_correct: Yup.boolean(),
  grading_data: Yup.object()
    .shape({
      teamId: Yup.mixed<number | string>().nullable(),
      playerId: Yup.mixed<number | string>().nullable(),
      playerName: Yup.string().nullable(),
      playerPosition: Yup.string().nullable(),
      teamName: Yup.string().nullable(),
      threshold: Yup.number().nullable(),
      comparison: Yup.string().oneOf(['over', 'under']).nullable(),
      fixtureData: Yup.object()
        .shape({
          fixtureId: Yup.string().required(),
          homeTeamId: Yup.string().required(),
          awayTeamId: Yup.string().required(),
          homeTeamName: Yup.string().required(),
          awayTeamName: Yup.string().required(),
          scheduledDate: Yup.string().required(),
          status: Yup.string()
            .oneOf(['scheduled', 'live', 'finished', 'postponed', 'cancelled'])
            .required(),
        })
        .nullable()
        .default(undefined),
    })
    .nullable()
    .default(undefined),
});
